import { makeStyles } from "@material-ui/core";
import { whiteGrey, white, backgroundColor } from "../../constants/colors";

const useStyles = makeStyles(({ breakpoints: { down } }) => ({
  mainForm: {
    backgroundColor: white,
    padding: "30px 60px",
    [down("sm")]: {
      padding: "30px 40px",
    },
    [down("xs")]: {
      padding: "25px 10px",
    },
  },
  contactBox: {
    [down("sm")]: {
      background: whiteGrey,
      padding: "35px 19px",
      borderRadius: "10px",
    },
  },
  secondaryForm: {
    backgroundColor: whiteGrey,
    padding: "50px 80px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    [down("sm")]: {
      padding: "30px 40px",
      backgroundColor: white,
    },
    [down("xs")]: {
      padding: "19px",
      backgroundColor: white,
      paddingBottom: "30px",
    },
  },
  formNavigationBtns: {
    [down("sm")]: {
      background: whiteGrey,
      padding: "10px 19px 30px 19px",
      borderBottomLeftRadius: "10px",
      borderBottomRightRadius: "10px",
    },
  },
  addNewBtn: {
    transition: "all 0.3s ease",
    background: "rgb(74 148 236 / 10%)",
    borderRadius: "10px",
    color: "#4A94EC",
    height: "64px",
    fontSize: "10px",
    "& h6": {
      fontFamily: "sbcBold",
    },

    "&:hover": {
      boxShadow: "0px 3px 14px rgba(0, 0, 0, 0.15)",
      cursor: "pointer",
    },

    [down("xs")]: {
      minWidth: "130px",
      flexDirection: "column",
      "& >div": {
        marginBottom: "8px",
      },
    },
  },
  contactIconWrapper: {
    height: "84px",
    width: "84px",
    borderRadius: "50%",
    backgroundColor: white,
  },
  tabSection: {
    marginBottom: "40px",
    [down("xs")]: {
      paddingTop: "10px",
      overflowX: "scroll",
      flexWrap: "nowrap",
      marginBottom: "10px",
    },
  },
  formHeader: {
    position: "relative",
    [down("xs")]: {
      "& h1": {
        fontSize: "19px",
      },
    },
  },
  actionBtn: {
    background: backgroundColor,
    borderRadius: "55px",
    minWidth: "170px",
    height: "38px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textTransform: "uppercase",
    cursor: "pointer",
    transition: "all 0.3s ease",
    "&:hover": {
      boxShadow: "0px 3px 14px rgba(0, 0, 0, 0.15)",
    },
    [down("md")]: {
      minWidth: "150px",
    },
    [down("sm")]: {
      minWidth: "140px",
    },
  },
  icon: {
    width: "84px",
    height: "84px",
    backgroundColor: white,
    borderRadius: "50%",
  },
}));

export default useStyles;
